import { Observability } from '@mews/framework/observability';
import { MewsTeam } from '@mews/enums';
import { DistributorThunkAction } from '../types';
import { getEnterpriseChainId } from '../modules/entities/enterprises/selectors';
import { getCurrentRoute, getSessionId } from '../modules/app/selectors';

export const setObservabilityUser =
    (enterpriseId: string): DistributorThunkAction =>
    (_dispatch, getState) => {
        if (enterpriseId == null) {
            return;
        }

        const state = getState();
        const sessionId = getSessionId(state);
        const chainId = getEnterpriseChainId(state, { enterpriseId });
        const route = getCurrentRoute(state);

        Observability.setUserContext({
            chainId,
            userId: sessionId,
            enterpriseId,
        });

        // Set initial labels including route
        Observability.updateLabels({
            chainId,
            enterpriseId,
            owner: MewsTeam.GuestExperience,
            userId: sessionId,
            route,
        });
    };

export const updateObservabilityLabels = (params: Omit<Parameters<typeof Observability.updateLabels>[0], 'owner'>) => {
    Observability.updateLabels({
        ...params,
        owner: MewsTeam.GuestExperience,
    });
};
